import { Coupon } from '@/resource/coupon/coupon.model';
import { UserStatus } from '@/resource/user/user.model';
import { axios } from '../axios';
import cookie, { COOKIE, COOKIE_EXPIRATION } from '../cookie';

export enum SubscriptionType {
  OneMonth = 'one-month',
  SixMonth = 'six-month',
  LifeTime = 'life-time',
}

export async function manageSubscription(): Promise<string | null> {
  let billingPortalUrl: string | null = null;

  try {
    const { data } = await axios.get('subscriptions/manage');

    billingPortalUrl = data.billingPortalUrl;
  } catch (error) {
    billingPortalUrl = null;
  }

  return billingPortalUrl;
}

export interface CreateSubscriptionParams {
  subscriptionType: SubscriptionType;
  coupon: string | null;
}

export async function createSubscription(
  params: CreateSubscriptionParams,
): Promise<string | null> {
  let checkoutUrl: string | null = null;

  try {
    const { data } = await axios.post('subscriptions', params);

    checkoutUrl = data.checkoutUrl;
  } catch (error) {
    checkoutUrl = null;
  }

  return checkoutUrl;
}

export interface CheckCouponParams {
  subscriptionType: SubscriptionType;
  coupon: string;
}

export async function checkCoupon(
  params: CheckCouponParams,
): Promise<Coupon | null> {
  let isValidCoupon = null;

  try {
    const { data } = await axios.get('subscriptions/coupon', {
      params: {
        coupon: params.coupon,
        subscription_type: params.subscriptionType,
      },
    });

    isValidCoupon = data;
  } catch (error) {
    isValidCoupon = null;
  }

  return isValidCoupon;
}

export async function getSubscriptionStatus(): Promise<UserStatus | null> {
  let userStatus: UserStatus | null = null;

  try {
    const { data } = await axios.get('users/status');
    if (data) {
      userStatus = data.status;
      cookie.set(COOKIE.STATUS, data.status, {
        sameSite: 'strict',
        expires: COOKIE_EXPIRATION,
      });
      cookie.set(COOKIE.IS_SUSPENDED, data.isSuspended ? 'true' : 'false', {
        sameSite: 'strict',
        expires: COOKIE_EXPIRATION,
      });
      cookie.set(COOKIE.ROLE, data.role, {
        sameSite: 'strict',
        expires: COOKIE_EXPIRATION,
      });
      cookie.set(COOKIE.AFFILIATE_CODE, data.affiliateCode, {
        sameSite: 'strict',
        expires: COOKIE_EXPIRATION,
      });
    }
  } catch (error) {
    userStatus = null;
  }

  return userStatus;
}

export async function createLifeTimeSubscription(): Promise<string | null> {
  let checkoutUrl: string | null = null;

  try {
    const { data } = await axios.post('subscriptions/life-time');

    checkoutUrl = data.checkoutUrl;
  } catch (error) {
    checkoutUrl = null;
  }

  return checkoutUrl;
}
